import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {ProjectReferenceContractAttributesService} from '../project-reference-contract-attributes.service';
import {ProjectReferenceContractAttributesResponse} from '../../models/project-reference-contract-attributes-response';
import {ProjectReferenceContractAttributesUpdateRequest} from '../../models/project-reference-contract-attributes-update-request';

const mockContractAttributes: ProjectReferenceContractAttributesResponse = {
    contractScope: {
        code: 'SCCAW00',
        title: 'Contractscope / aard van het werk',
        multiple: false,
        values: [{
            id: 'SCCAW00_004',
            title: 'Bouwteam (ontwerp en realisatie)',
            parentIds: [],
            order: null
        }, {
            id: 'SCCAW00_003',
            title: 'Ontwerp',
            parentIds: [],
            order: null
        }, {
            id: 'SCCAW00_006',
            title: 'Anders',
            parentIds: [],
            order: null
        }, {
            id: 'SCCAW00_002',
            title: 'Ontwikkeling',
            parentIds: [],
            order: null
        }, {
            id: 'SCCAW00_005',
            title: 'Realisatie',
            parentIds: [],
            order: null
        }, {
            id: 'SCCAW00_001',
            title: 'Koop',
            parentIds: [],
            order: null
        }],
        selectedValueId: null
    },
    implementation: {
        code: 'TEMP001',
        title: 'Uitvoering',
        multiple: false,
        values: [{
            id: 'TEMP001_002',
            title: 'Wel uitvoeren',
            parentIds: [],
            order: null
        }, {
            id: 'TEMP001_001',
            title: 'Niet uitvoeren',
            parentIds: [],
            order: null
        }],
        selectedValueId: 'TEMP001_001'
    },
    buyerParticipation: {
        code: 'SCKPP00',
        title: 'Kopersparticipatie',
        multiple: false,
        values: [{
            id: 'SCKPP00_005',
            title: 'Anders',
            parentIds: [],
            order: null
        }, {
            id: 'SCKPP00_001',
            title: 'Nee',
            parentIds: [],
            order: null
        }, {
            id: 'SCKPP00_003',
            title: 'CPO',
            parentIds: [],
            order: null
        }, {
            id: 'SCKPP00_002',
            title: 'CO-creatie',
            parentIds: [],
            order: null
        }, {
            id: 'SCKPP00_004',
            title: 'Medeopdrachtgeverschap',
            parentIds: [],
            order: null
        }],
        selectedValueId: 'SCKPP00_005'
    },
    realizationPosition: {
        code: 'SCPBR00',
        title: 'Positie binnen de realisatie',
        multiple: false,
        values: [{
            id: '570427b7-7292-4477-80f9-0b3f82489bbe',
            title: 'Nevenaanneming excl coördinatie',
            parentIds: [],
            order: null
        }, {
            id: '24fac7e3-0ed6-4115-a8d2-3054059bb601',
            title: 'Geen verdere uitsplitsing',
            parentIds: [],
            order: null
        }],
        selectedValueId: '24fac7e3-0ed6-4115-a8d2-3054059bb601'
    },
    contractPrecondition: {
        code: 'SCRVC00',
        title: 'Randvoorwaarden contractvorm',
        multiple: false,
        values: [{
            id: 'f25c7c4d-c6d1-4949-8b00-019e303b09d0',
            title: 'UAV-2012',
            parentIds: [],
            order: null
        }, {
            id: 'a7bfe1cb-5a00-471c-ab1a-4a40ec1f4b21',
            title: 'UAV-GC 2005',
            parentIds: [],
            order: null
        }],
        selectedValueId: 'a7bfe1cb-5a00-471c-ab1a-4a40ec1f4b21'
    },
    methodOfAcquisition: {
        code: 'KRWVA00',
        title: 'Wijze van acquisitie',
        multiple: false,
        values: [{
            id: 'c41c84ba-a1c3-40c0-a9d2-2c126f8c5cc8',
            title: '1op1',
            parentIds: [],
            order: null
        }, {
            id: '132ea7be-6a10-47eb-bac9-65791f22eb65',
            title: 'Zonder voorstel',
            parentIds: [],
            order: null
        }, {
            id: '7fa8e364-e85f-4e99-b5cc-ae324897bd7b',
            title: 'In concurrentie EU',
            parentIds: [],
            order: null
        }, {
            id: '28f73d5b-5ffc-4d67-8d95-fd92a649c7bd',
            title: 'In concurrentie niet EU',
            parentIds: [],
            order: null
        }, {
            id: '7ef8007b-9776-4309-b338-38562f8a218f',
            title: 'Anders',
            parentIds: [],
            order: null
        }],
        selectedValueId: 'c41c84ba-a1c3-40c0-a9d2-2c126f8c5cc8'
    },
    contractPrice: 1,
    additionalWork: 800
}

@Injectable({
    providedIn: 'root'
})
export class ProjectReferenceContractAttributesServiceMock implements ProjectReferenceContractAttributesService {

    getContractAttributes(refId: number): Observable<ProjectReferenceContractAttributesResponse> {
        return of(mockContractAttributes)

    }

    putContractAttributes(request: ProjectReferenceContractAttributesUpdateRequest): Observable<ProjectReferenceContractAttributesResponse> {
        return of(mockContractAttributes)
    }
}
